import React from 'react';
import { observer } from 'mobx-react';

import { Tooltip } from '@mui/material';

import DueDate from 'components/DueDate';

import { Value } from 'components/DueDate/styles';

import { DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR } from 'core/constants';

import { colors } from 'theme/colors';

import { ScheduleStatus, TaskStatus } from 'utils/api/modules/tasks/tasks.constants';

import { formatDateOmitCurrentYear } from 'utils/date';
import { formatMoment } from 'utils/formatters/timezone';

interface TaskDueDateProps {
  date: string;
  status?: TaskStatus | ScheduleStatus.Overdue;
  // Opt-in for audit surfaces only: renders due time on today/tomorrow/overdue rows and adds the
  // full-timestamp hover tooltip. Tasks and Acknowledgements leave this off and stay date-only.
  showTime?: boolean;
}

const TaskDueDate: React.FC<TaskDueDateProps> = ({ date, status, showTime }): React.ReactElement => {
  if (date === undefined || date === null) {
    return <Value $color={colors.text.secondary}>No Due Date</Value>;
  }

  const content =
    status === TaskStatus.Completed ? (
      <Value $color={colors.text.secondary}>{formatDateOmitCurrentYear(date, showTime)}</Value>
    ) : (
      <DueDate date={date} status={status} showTime={showTime} />
    );

  if (showTime) {
    return (
      <Tooltip title={formatMoment(date, DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR)} arrow>
        <span>{content}</span>
      </Tooltip>
    );
  }

  return content;
};

export default observer(TaskDueDate);
